import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiGmail} from 'react-icons/si'

//import {FiDribbble} from 'react-icons/fi'

const HeaderSocial = () => {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/anmolsharma23/' target="_blank"><BsLinkedin/></a>
        <a href='https://github.com/anmol23oct' target="_blank"><FaGithub/></a>
        <a href='mailto:anmol.sharma230796@gmail.com' target="_blank"><SiGmail/></a>

    </div>
  )
}

export default HeaderSocial